import { useEffect, useRef, useState } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { imageValidation } from "../../../config";
import { CrossIcon } from "../../../components/Common/SvgIcons";


export const ProfileUpdate = ({ handleEditClick, handlePhotoUplaod, image, cropperRef, setFileInputKey, isremoved, isCdnImage, setIsDisabled, updatedImage, croppedImage, validationMessage, setValidationMessage }) => {
    const [isDragging, setIsDragging] = useState(false);
    const { maxFileSize, allowedFormats } = imageValidation
    const maxSize = maxFileSize * 1024 * 1024; // 1MB in bytes
    const formatsList = allowedFormats.map((format) => `.${format.split('/')[1]}`).join(", ")
    const [imageForCrop, setImageForCrop] = useState(null)
    const croppedCanvas = cropperRef?.current?.cropper ? cropperRef?.current?.cropper.getCroppedCanvas()?.toDataURL() : null;

    useEffect(() => {
        setIsDisabled(imageForCrop === updatedImage)
    }, [imageForCrop, updatedImage])

    useEffect(() => {
        if (croppedCanvas && croppedImage && croppedCanvas !== croppedImage) {
            setIsDisabled(false)
        }
    }, [croppedCanvas, croppedImage])

    useEffect(() => {
        setImageForCrop(image)
    }, [image, isremoved])

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(true);
    };

    const handleDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setIsDragging(false);

        handlePhotoUplaod(event, 'drag')
        console.log('Dropped files:', event.dataTransfer.files);
        // Handle the dropped files here
    };

    const resetCrop = () => {
        if (cropperRef.current) {
            cropperRef.current.cropper.reset();
        }
    };

    const handleDelete = () => {
        setImageForCrop(null)
        setFileInputKey(Date.now());
        if (cropperRef.current) {
            cropperRef.current.cropper?.clear(); // Clear cropper data if any
            cropperRef.current = null; // Set cropperRef to null

        }
    };

    return (
        <div className="profile-update-view">
            <span className="main-title">Upload from your device</span>
            {validationMessage &&
                <div className="validation-message-container">
                    <span className="message">{validationMessage}</span>
                    <div className="close-icon" onClick={() => setValidationMessage(null)}>
                        <CrossIcon />
                    </div>
                </div>
            }
            {
                !imageForCrop ?
                    <div
                        className={`image-details-container ${isDragging ? 'dragging' : ''}`}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}

                    >
                        <span className="title">Drag and drop your file here</span>
                        <span className="sub-title">{`Maximum file size is ${maxFileSize} MB. (Only ${formatsList} formats supported)`}</span>
                        <button className="primary-button" onClick={() => {
                            handleEditClick('upload');

                        }}>Browse Files</button>
                    </div>
                    :
                    <div
                        className={`image-details-container-with-image`}
                    >
                        {!isCdnImage && <span className="title">To crop, drag the highlighted area</span>}
                        {
                            isCdnImage ?
                                <img src={imageForCrop} ref={cropperRef} className="profile-image" />
                                :
                                <Cropper
                                    style={{ height: 200, width: 200 }}
                                    initialAspectRatio={1}
                                    preview=".img-preview"
                                    src={imageForCrop}
                                    ref={cropperRef}
                                    viewMode={1}
                                    guides={true}
                                    minCropBoxHeight={10}
                                    minCropBoxWidth={10}
                                    background={false}
                                    responsive={true}
                                    checkOrientation={false}
                                />
                        }

                        {!isCdnImage && <span className="sub-title" onClick={resetCrop}>Reset crop area</span>}
                        <div className="buttons-container">
                            <button className="secondary-button" onClick={handleDelete}>Remove file</button>

                            <button className="primary-button" onClick={() => {
                                handleEditClick('upload');

                            }}>Upload new</button>

                        </div>
                    </div>

            }
        </div>
    );
};
export default ProfileUpdate